import React, { useState } from "react";
import axios from "axios";
import { Button, Typography, CircularProgress } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { postAPI } from ".";
import { BASE_URL } from "../../utils/axiosSetup";

const ExcelUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file && (file.name.endsWith(".xlsx") || file.name.endsWith(".xls"))) {
      setSelectedFile(file);
      setMessage(""); // Clear previous messages
    } else {
      alert("Please select a valid Excel file (.xlsx or .xls)");
      setSelectedFile(null);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select an Excel file first.");
      return;
    }

    const formData = new FormData();
    formData.append("picture", selectedFile);

    try {
      setUploading(true);
      setMessage("");

      const response = await postAPI(`${BASE_URL}/visitor/auth/bulk-register`, // Change URL if needed
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setMessage("File uploaded successfully!");
    } catch (error) {
      console.error("Upload error:", error);
      setMessage(
        error.response?.data?.message || "Error uploading file. Please try again."
      );
    } finally {
      setUploading(false);
      setSelectedFile(null);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center" }}>
      {!selectedFile &&
        <div className="">
          <input
            accept=".xlsx,.xls"
            style={{ display: "none" }}
            id="excel-file-upload"
            type="file"
            onChange={handleFileChange}
          />
          <label htmlFor="excel-file-upload">
            <Button variant="contained" component="span" startIcon={<UploadFileIcon />}>
              Bulk Import
            </Button>

          </label>
        </div>
      }
      {
        selectedFile && <Button
          variant="contained"
          component="span"
          onClick={handleUpload}
          disabled={!selectedFile || uploading}
        >
          {uploading ? <CircularProgress size={24} /> : "Click to Upload"}
        </Button>
      }
    </div>
  );
};

export default ExcelUpload;
